import datacenterSort from '../../util/sorters';
import { appDefault } from '../../config/config';

export default function sortComparator(
  currentHeader,
  baseDistribution,
  mapBaseColumn
) {
  return ({ text: val1 }, { text: val2 }, data1, data2, isInverted) => {
    const datacenterSortResult = datacenterSort(
      val1,
      val2,
      currentHeader,
      isInverted,
      data1.data[baseDistribution],
      data2.data[baseDistribution],
      data1.data.isSummary,
      data2.data.isSummary
    );

    // @TODO - build geo-sorting tied no-data vals into each sort
    const noDataSort = val1 === val2 &&
      appDefault.dataNotAvailable.indexOf(val1) > -1 &&
      appDefault.dataNotAvailable.indexOf(val2) > -1;

    // If the sort returns a 0, we've tied.
    // If we are also comparing on a header that is not the base,
    // then we are to re-sort based on geography.
    if ((datacenterSortResult === 0 || noDataSort) &&
      baseDistribution !== currentHeader.characteristic) {
      return (isInverted ? -1 : 1) * datacenterSort(
        data1.data[baseDistribution],
        data2.data[baseDistribution],
        { type: 'geography' },
        isInverted,
        data1.data[baseDistribution],
        data2.data[baseDistribution],
        data1.data.isSummary,
        data2.data.isSummary
      );
    }

    // If there is mapBaseColumn, we are in a multiGeo indicator
    // In that case, see if we are sorting on the base distribution.
    // If we are, then sort on geo after sorting on base w/result of 0.
    // This indicates that sorting on base didn't change anything, but we
    // still need to sort on geography.
    if (mapBaseColumn && baseDistribution === currentHeader.characteristic) {
      return datacenterSortResult === 0 ?
        datacenterSort(
          data1.data[mapBaseColumn],
          data2.data[mapBaseColumn],
          { type: 'geography' },
          isInverted,
          data1.data[mapBaseColumn],
          data2.data[mapBaseColumn],
          data1.data.isSummary,
          data2.data.isSummary
        ) : datacenterSortResult;
    }

    // @TODO - find a better way to send in summary info
    // this problem arises from removing the (All) string from
    // the data for rendering purposes.  We already added an
    // isSummary prop to the data, so we're using it here
    return datacenterSort(
      val1,
      val2,
      currentHeader,
      isInverted,
      data1.data[baseDistribution],
      data2.data[baseDistribution],
      data1.data.isSummary,
      data2.data.isSummary
    );
  };
}



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/table/sortComparator.js
 **/